import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "发票")
], -1)
const _hoisted_2 = {
  class: "form-dialog__content",
  style: {"display":"block"}
}
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "发票号码", -1)

import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseUpload,
  BaseIcon,
  BaseImage,
  BaseInput
} from 'xrk-components';

import { DeleteFilled } from '@element-plus/icons-vue';
import { uploadApi } from '@data-source/common/apis';

const disabled = true;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-gt-p-upload-dialog',
  props: {
    remove: {},
    invoiceImgList: {}
  },
  setup(__props: any) {

const props = __props;

const formRef = ref(null);
const formData = ref({
  list: props.invoiceImgList
});

const formRules = {
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('请重新上传发票'));
        }
        if (v.some(item => !item.invoiceNo)) {
          return callback(new Error('请填写发票信息'));
        }
        callback();
      }
    }
  ]
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "680px",
    class: "form-dialog form-dialog--label120",
    title: "上传发票",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            ref_key: "formRef",
            ref: formRef,
            "label-position": "right",
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(BaseFormItem), {
                  label: "发票照片",
                  prop: "list"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (!disabled)
                        ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                            key: 0,
                            style: {"margin-bottom":"20px"},
                            autoUpload: "",
                            btnText: "上传",
                            tipText: "只能上传jpg/png，且每份不超过50MB",
                            listType: null,
                            accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                            limit: 20,
                            limitSize: 50,
                            multiple: false,
                            showFileList: false,
                            "http-request": _unref(uploadApi)
                          }, null, 8, ["http-request"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.list, (img) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: {"position":"relative","display":"flex","align-items":"flex-end","margin-bottom":"30px"},
                          key: img.invoicePic
                        }, [
                          _createVNode(_unref(BaseImage), {
                            style: {"width":"200px","height":"120px"},
                            src: img.invoicePic,
                            "preview-src-list": [img.invoicePic]
                          }, null, 8, ["src", "preview-src-list"]),
                          _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createVNode(_unref(BaseInput), {
                              style: {"width":"240px"},
                              disabled: disabled,
                              modelValue: img.invoiceNo,
                              "onUpdate:modelValue": ($event: any) => ((img.invoiceNo) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          (!disabled)
                            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                                key: 0,
                                size: "18",
                                color: "#ED7067",
                                style: {"cursor":"pointer","position":"absolute","right":"-35px","bottom":"10px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(DeleteFilled))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})